import b from 'b_';
import cx from 'classnames';
import isEqual from 'lodash/isEqual';
import { Link, Text } from 'platform-components';
import { withRouter } from 'platform-components/src/components/router/router';
import { withRouterPath } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import ym from 'react-yandex-metrika';
import { compose } from 'redux';

import Carousel from 'common.components/journal-carousel/journal-carousel';
import { getRedirectPathForLesson } from 'utils/lesson';

import Scroller from '../__carousel-scroller/course-journal__carousel-scroller';

import './course-journal__lessons-carousel.scss';

// Количество элементов скролящихся за один клик.
const CAROUSEL_STEP = 5.5;
// На экране видно 12 уроков за раз
const VISIBLE_ITEMS_COUNT = 12;

class CourseJournalLessonsCarouselComponent extends React.Component {
    static propTypes = {
        colorScale: PropTypes.func,
        courseId: PropTypes.number,
        getRouterPath: PropTypes.func.isRequired,
        heading: PropTypes.bool,
        hideDescription: PropTypes.func,
        lessons: PropTypes.array.isRequired,
        match: PropTypes.object.isRequired,
        showDescription: PropTypes.func,
        efficiencyByProblems: PropTypes.array.isRequired,
        showPastes: PropTypes.bool,
    };

    static contextTypes = {
        addScrollCarouselListener: PropTypes.func.isRequired,
    };

    state = {
        // текущее крайнее положение карусели ('left'/'right')
        position: 'left',
    };

    componentDidMount() {
        this.context.addScrollCarouselListener(this.carousel.scroll);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            !isEqual(nextProps.lessons, this.props.lessons) ||
            nextState.position !== this.state.position ||
            this.props.showPastes !== nextProps.showPastes
        );
    }

    onScroll = ({ position, length }) => {
        let nextPosition = false;
        if (position === 0) {
            nextPosition = 'left';
        } else if (position === length) {
            nextPosition = 'right';
        }
        this.setState({ position: nextPosition });
    };

    onMouseEnterLink = (lessonId, { target }) => {
        const { showDescription, lessons } = this.props;
        const hoveredLesson = lessons.find((lesson) => lesson.id === lessonId);
        const {
            id,
            date_assignment: dateAssignment,
            lesson: { name },
            mode,
        } = hoveredLesson;

        if (showDescription) {
            showDescription({ id, name, dateAssignment, owner: target, mode });
        }
    };

    onMouseLeaveLink = () => {
        const { hideDescription } = this.props;

        if (hideDescription) {
            hideDescription();
        }
    };

    handleLessonLinkClick = (clessonId) => {
        const {
            match: {
                params: { subject },
            },
        } = this.props;

        ym('reachGoal', 'urlClessonResults', {
            subject,
            type: 'f_journal',
            content: 'results',
            clessonId,
        });
    };

    render() {
        const {
            colorScale,
            getRouterPath,
            heading,
            lessons,
            efficiencyByProblems,
            courseId,
            showPastes,
            match: {
                params: { subject },
            },
        } = this.props;

        const { position } = this.state;
        let className = b('course-journal', 'lessons-carousel', { position });
        if (lessons.length < VISIBLE_ITEMS_COUNT) {
            className = cx(className, 'course-journal__lessons-carousel_position_right');
        }

        // eslint-disable-next-line complexity
        const items = lessons.map((lesson, i) => {
            const isLessonSimpleCell = lesson.value !== null && lesson.value !== undefined;

            const status = heading && lesson && lesson.status;
            const path = getRedirectPathForLesson(status);
            const lessonLink = heading ? `${getRouterPath(path, { subject })}?lessonId=${lesson.id}` : null;
            const efficiency = !heading ? efficiencyByProblems[i] : null;
            // 0 может приходить и для карточки, решенной с ошибкой, и для нерешавшегося занятия
            const wasNotSolved = lesson.value === null && efficiency === 0;
            const isEmptyItem = !heading && (efficiency === null || wasNotSolved);

            const showCheating = showPastes && lesson.isCheat;

            const background =
                !heading &&
                (showPastes // eslint-disable-line no-nested-ternary
                    ? lesson.isCheat
                        ? '#66A7F6'
                        : isLessonSimpleCell && '#EEEEF0'
                    : isLessonSimpleCell && colorScale?.(lesson.value));

            return (
                <div
                    className={isEmptyItem && 'course-journal__empty-cell'}
                    key={i}
                    style={background ? { background } : undefined}
                >
                    {heading && (
                        <Link
                            isRouter
                            onClick={() => this.handleLessonLinkClick(lesson.id)}
                            onMouseEnter={(e) => this.onMouseEnterLink(lesson.id, e)}
                            onMouseLeave={this.onMouseLeaveLink}
                            theme={Link.THEME.PRIMARY}
                            to={lessonLink}
                        >
                            <Text size={Text.SIZE.S} weight={Text.WEIGHT.L}>
                                {i + 1}
                            </Text>
                        </Link>
                    )}
                    {!heading && (
                        <div
                            onMouseEnter={showCheating ? this.props.showDescription : undefined}
                            onMouseLeave={showCheating ? this.props.hideDescription : undefined}
                        >
                            {isLessonSimpleCell ? <Text>{efficiency}</Text> : '\u00a0'}
                        </div>
                    )}
                </div>
            );
        });

        return (
            <div className={className}>
                <Scroller direction="left" withArrow={heading} />
                <Carousel
                    courseId={courseId}
                    easing="easeInOutCubic"
                    onScroll={this.onScroll}
                    ref={(c) => (this.carousel = c)}
                    step={CAROUSEL_STEP}
                >
                    {items}
                </Carousel>
                <Scroller direction="right" withArrow={heading} />
            </div>
        );
    }
}

export const CourseJournalLessonsCarousel = compose(withRouterPath, withRouter)(CourseJournalLessonsCarouselComponent);
